export default __webpack_public_path__ + "static/media/home-image-button-youth-ministry.2b85d3c5.jpg";